/**
 * Set B «Спортивный скос»: colours, faces and sizes copied from the approved mockup
 * (`.claude/docs/match-video/video-sets-spec.html`, classes `.b-*`). Coordinates are the 1920×1080 frame.
 */
export const SLASH = {
  bg: '#101012',
  red: '#e10600',
  redDark: '#8f0400',
  dark: '#1b1b22',
  darkEnd: '#2a2a35',
  white: '#ffffff',
  ink: '#101012',
  plateTeam: '#55555f',
  yellow: '#ffb400',
} as const;

const RUSSO = '"Russo One"';

export const SLASH_FONTS = {
  champ: (px: number) => `600 ${px}px Oswald`,
  round: (px: number) => `400 ${px}px ${RUSSO}`,
  teamName: (px: number) => `700 ${px}px Oswald`,
  score: (px: number) => `400 ${px}px ${RUSSO}`,
  foot: (px: number) => `600 ${px}px Oswald`,
  tag: (px: number) => `400 ${px}px ${RUSSO}`,
  number: (px: number) => `400 ${px}px ${RUSSO}`,
  player: (px: number) => `700 ${px}px Oswald`,
  plateTeam: (px: number) => `500 ${px}px Oswald`,
  minute: (px: number) => `400 ${px}px ${RUSSO}`,
  danger: (px: number) => `600 ${px}px Oswald`,
} as const;

/** Every face of the intro — loaded before the first frame. */
export const SLASH_INTRO_FONTS: readonly string[] = [
  SLASH_FONTS.champ(34),
  SLASH_FONTS.round(38),
  SLASH_FONTS.teamName(60),
  SLASH_FONTS.score(150),
];

/** Frame margins of the plates (`.b-plate`: left 96, bottom 80) — the right one mirrors the left. */
export const PLATE_LEFT = 96;
export const PLATE_BOTTOM = 80;

/** Background layers reach 40 px past the frame (`inset: -40px`), so the shake and the push-in never bare an edge. */
export const BLEED = 40;
